import {
  Injectable,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
// import { Component, OnInit, OnDestroy } from '@angular/core';

import { Vehicle, VehicleCommandSeend } from '../models/vehicle';
import RefData from '../data/refData';
import * as L from 'leaflet';
import * as moment from 'moment';
import 'leaflet.markercluster';
import 'leaflet.markercluster.freezable';
import { ItemIcon } from 'src/app/profile-config/models/interfaces';

import { VehicleConfigService } from './vehicle-config.service';
import { WebSocketDataService } from './webSocketData.service';
import { VehicleService } from './vehicle.service';
import { FollowService } from './follow.service';
import { TabService } from 'src/app/panel/services/tab.service';
import { UserTracker } from 'src/app/multiview/models/interfaces';
import { UserDataService } from 'src/app/profile-config/services/user-data.service';
import { DriversService } from 'src/app/drivers/services/drivers.service';
import { HttpClient } from '@angular/common/http';
import { MomentService } from './moment.service';
import { UserIconsService } from 'src/app/profile-config/services/user-icons.service';
import { tap } from 'rxjs/operators';
import { convertSecondsToTimeString } from '../components/content-panel-vehicles/helpers/convert-seconds-to-time-string';
import { UnitWithTransmissionStatus } from 'src/app/units/models/unit-transmission-status';
import { UnitTransmissionStatusService } from 'src/app/units/services/unit-transmission-status.service';
import { VehicleHistoryDrawerParams } from 'src/app/historial/models/vehicle-history-drawer.model';
import { PermissionService } from 'src/app/permiss/permission.service';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  gifBase64: string | undefined;
  @ViewChild('popupText') popupText!: ElementRef;
  @Output() imei = new EventEmitter<any>();
  @Output() onClickHistoryButton =
    new EventEmitter<VehicleHistoryDrawerParams>();
  @Output() onClickCommandButton =
    new EventEmitter<VehicleCommandSeend>();

  public map!: L.Map;
  public respuesta: any = [];
  // public markerClusterGroup!: L.MarkerClusterGroup;
  public markerClusterGroup!: any;
  public markerClusterData!: any;
  public markerClusterGroupOnda!: any;
  public leafletEvent!: L.LeafletEvent;
  private dataFitBounds: [string, string][] = [];
  private marker: any = [];
  private markerOnda: any = [];
  private polylineTail: any = [];
  private polylineTailTrace: any = [];
  private statusMap: boolean = false;
  private statusIcon: boolean = false;
  private interval!: any;
  private time: any = 1000;
  private time_stop = 'Calculando ...';
  private count = 0;
  private intervalStatus: boolean = false;
  private imeiPopup = 'ninguno';

  private clustering = true;
  private coords_vehicle: any[] = [];

  dif_mayor = 0.0;
  dif_divide = 0.0;
  dif_X = 0.0;
  dif_Y = 0.0;
  direction = '';
  final_direction = '';
  direction_X = '';
  direction_Y = '';
  // public mensaje: any = function(){
  //   console.log("lalalalal");
  // }
  // setInvterval = setInterval;

  timeNow: any = []; // Array para almacenar los tiempos
  timeWait: number = 7200000; // 7200 segundos en milisegundos
  //timeWait: number = 5000;

  @Output() sendData = new EventEmitter<any>();
  @Output() changeEye = new EventEmitter<any>();

  private units: UnitWithTransmissionStatus[] = [];

  constructor(
    public vehicleService: VehicleService,
    private followService: FollowService,
    private webSocketDataService: WebSocketDataService,
    private tabService: TabService,
    private userDataService: UserDataService,
    private userIconsService: UserIconsService,
    private vehicleConfigService: VehicleConfigService,
    private driversService: DriversService,
    private http: HttpClient,
    private momentService: MomentService,
    unitTransmissionStatusService: UnitTransmissionStatusService,
    private permissionService: PermissionService
  ) {
    // this.interval = setInterval(function(this){
    //   // this.localStorage
    //   this.mensaje();
    //   console.log("calculando ..",this);
    // },6000);
    this.markerClusterGroup = L.markerClusterGroup({
      removeOutsideVisibleBounds: true,
      zoomToBoundsOnClick: false,
    });
    //PARA ONDAS
    this.markerClusterGroupOnda = L.markerClusterGroup({
      removeOutsideVisibleBounds: true,
      zoomToBoundsOnClick: false,
    });

    this.vehicleService.drawIconMap.subscribe(() => {
      this.onDrawIcon(this.map);
    });
    this.vehicleService.dataCompleted.subscribe((vehicles) => {
      if (this.tabService.currentTab == 'main-panel') {
        this.onDrawIcon(this.map);
      }
    });
    this.webSocketDataService.callback.subscribe((res) => {
      this.monitor(res, this.map);
    });
    this.followService.callback.subscribe(async (IMEI) => {
      const vehicleFound = await this.searchVehicleByImei(IMEI);
      await this.setFollowVehicle(vehicleFound!);
      await this.updateVehiclesFollowing(vehicleFound!);
      this.followVehicle(this.map);
      if (vehicleFound!.eye == false) {
        this.eyeClick(vehicleFound!); // Mostrar el Vehicle
      }
    });
    this.vehicleService.clickIcon.subscribe(async (IMEI) => {
      const vehicleFound = await this.searchVehicleByImei(IMEI);
      this.followClickIcon(this.map, vehicleFound!);
      if (vehicleFound!.eye == false) {
        this.eyeClick(vehicleFound!); // Mostrar el Vehicle
      }
    });
    this.vehicleService.clickEye.subscribe(async (IMEI) => {
      const vehicleFound = await this.searchVehicleByImei(IMEI);
      this.eyeClick(vehicleFound!);
    });
    this.vehicleService.setGroupingShow.subscribe(async (resp) => {
      // console.log(resp.show);
      await this.setGroupEyeClick(resp.vh, resp.show);
      // enviar todos los vehicles?
    });
    // FUNCTION FORGOTTEN
    // this.vehicleService.clickEyeAll.subscribe((res) => {
    //   this.eyeClickAll();
    // });
    this.vehicleService.clickTag.subscribe(async (IMEI) => {
      const vehicleFound = await this.searchVehicleByImei(IMEI);
      await this.setTag(vehicleFound!);
      this.tagClick(vehicleFound!);
    });
    this.vehicleService.clickDriver.subscribe(async (IMEI) => {
      const vehicleFound = await this.searchVehicleByImei(IMEI);
      this.tagDriver(vehicleFound!);
    });
    //CAMBIO DE NOMBRE/COD/NOMBRE
    this.vehicleService.clickSelection.subscribe((res) => {
      this.changeNameVehicles(res);
    });
    //ACTUALIZAR NOMBRE DEL VEHICLE
    this.vehicleConfigService.updateName.subscribe(async (vehicle) => {
      const vehicleFound = await this.searchVehicleByImei(vehicle.tracker_imei);
      this.updateNameMarker(vehicleFound!);
    });
    //ACTUALIZAR TOOLTIP Y POPUP INFO
    this.vehicleService.reloadNameDriver.subscribe((res) => {
      this.updateNameDriver(res);
    });

    unitTransmissionStatusService.getUnitsTransmissionStatus
      .pipe(
        tap((_) => {
          this.units = _;
          this.renderVehiclesTransmission();
          if (this.currentPopupData) {
            this.createPopupWithUnitService(this.currentPopupData);
          }
        })
      )
      .subscribe();

    this.vehicleService.calcTimeStop.subscribe((data) => {
      if (this.units.length > 0) {
        //RAFA CAMBIO ESTO PREGUNTAR
        this.createPopupWithUnitService(data);
        return;
      }

      // console.log("event time stop res = ",data);
      let tiempoParada = '';
      //
      let aux_vehicle = this.vehicleService.getVehicle(data.imei);
      //
      let a = moment(new Date(data.dt_tracker));
      let b = moment(new Date());
      let d = moment(new Date(aux_vehicle.dt_tracker));

      /*
      c es el tiempo que demora en retornar la info desde backend (latencia)
      e corresponde a la ultima transmision???
      */
      let c = b.diff(a, 'seconds'); //retorno
      let e = d.diff(a, 'seconds'); //diff fecha
      // let c = 100;
      //dt_tracker es fecha tracker
      // console.log("speed  = ",data.speed);
      // console.log("calc c = ",c);
      // console.log("calc e = ",e);
      if (e == 0) {
        if (data.speed > 3 && c > 60) {
          // console.log("se cumplio condicion : item.speed > 3 km/h && c > 60 seg ");
          tiempoParada = '0 s';
        } else if (parseInt(data.res) == -1) {
          tiempoParada = 'Apagado mas de un día'; //"No se encontro Datos";
        } else if (parseInt(data.res) == -2) {
          tiempoParada = 'Duración mayor a 1 Dia';
        } else if (parseInt(data.res) == -3) {
          tiempoParada = 'En movimiento...';
        } else if (parseInt(data.res) == -5) {
          //inicio de parada
          tiempoParada = '0 s';
        } else if (parseInt(data.res) == -6) {
          //inicio de parada
          tiempoParada = '...Avise a soporte';
        }

        // console.log("tiempoParada = ",tiempoParada);
        let aux = {
          imei: data.imei,
          name: data.name,
          dt_tracker: data.dt_tracker.toLocaleString(),
          nameconvoy: data.nameconvoy,
          namegrupo: data.namegrupo,
          nameoperation: data.nameoperation,
          namedriver: data.namedriver,
          longitud: data.longitud,
          latitud: data.latitud,
          speed: data.speed,
          ref: data.direction,
          tiempoParada: tiempoParada,
        };

        // console.log('DATA en MAP SERVICE ---------------->',data,aux);
        this.imeiPopup = data.imei;
        // this.time_stop = tiempoParada;
        this.printPopup(aux);
      }
    });
  } //FIN DE CONSTRUCTOR

  private currentPopupData: any;

  private createPopupWithUnitService(data: any) {
    if (this.units.length > 0) {
      const unit = this.units.find((unit) => unit.GNSSIMEI == data.imei);
      // RAFA antes estaba como driver
      const nameDriver = data.namedriver
        ? data.namedriver
        : 'Conductor desconocido';
      this.currentPopupData = data;
      const infoPopup = {
        imei: unit?.GNSSIMEI,
        name: unit?.unitName,
        dt_tracker: unit?.device.trackerDate.toLocaleString(),
        nameconvoy: unit?.convoy,
        namegrupo: unit?.group,
        nameoperation: unit?.operation,
        namedriver: nameDriver,
        longitud: data.longitud,
        latitud: data.latitud,
        speed: unit?.device.speed,
        ref: data.direction || 'Cargando...',
        tiempoParada:
          unit?.transmissionStatusId === 1
            ? '0s'
            : convertSecondsToTimeString(unit?.latlngTimeElapsed || 0, {
                shortFormat: true,
                showZeros: false,
              }),
      };
      this.imeiPopup = unit?.GNSSIMEI || '';
      this.printPopup(infoPopup);
    }
  }

  setNameGroup(nameOpe: string, nameGru: string, nameCon: string): string {
    if (nameCon != 'Unidades sin convoy') {
      if (nameGru != 'Unidades sin grupo') {
        if (nameOpe != 'Unidades sin operación') {
          return nameOpe + ' / ' + nameGru + ' / ' + nameCon;
        } else {
          return nameCon + ' / ' + nameGru;
        }
      } else {
        return nameCon;
      }
    } else {
      return '';
    }
  }

  printPopup(data: any): void {
    let object = this.markerClusterGroup.getLayers();
    // console.log('objetc ', this.marker[data.imei]);
    // console.log('data ', data);
    console.log('printpopup', data);

    if (data?.imei) {
      try {
        const vehicle = this.vehicleService.getVehicle(data.imei);
        if (
          vehicle?.name &&
          typeof vehicle.name === 'string' &&
          vehicle.name.trim()
        ) {
          data.name = vehicle.name;
        }
      } catch (error) {
        console.warn(
          'Error al asignar vehicle name para IMEI:',
          data.imei,
          error
        );
      }
    }

    let key = Object.keys(object).find(
      (key) => object[key]._leaflet_id == this.marker[data.imei!]._leaflet_id
    );
    if (key != undefined && key) {
      const nameGroup = this.setNameGroup(
        data.nameoperation,
        data.namegrupo,
        data.nameconvoy
      );
      const googleMapsLink = `https://www.google.com/maps?q=${data.latitud},${data.longitud}`;
      const dt_tracker = data.dt_tracker
        ? (() => {
            try {
              const dateStr = data.dt_tracker.toString().trim();

              // Normalizar AM/PM con espacios flexibles
              let normalizedDateStr = dateStr
                .replace(/p\.\s*m\./gi, 'PM')
                .replace(/a\.\s*m\./gi, 'AM')
                .replace(/\s+/g, ' '); // Normalizar espacios múltiples

              // Regex más flexible para diferentes formatos
              const dateTimeMatch = normalizedDateStr.match(
                /(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4}),?\s*(.+)/
              );

              if (dateTimeMatch) {
                const [, day, month, year, time] = dateTimeMatch;
                normalizedDateStr = `${month}/${day}/${year} ${time}`;
              }

              const parsedDate = new Date(normalizedDateStr);

              if (isNaN(parsedDate.getTime())) {
                console.error('(MAP) ERROR AL PARSEAR FECHA:', {
                  original: dateStr,
                  normalized: normalizedDateStr,
                  parsedDate: parsedDate,
                  getTime: parsedDate.getTime(),
                });
                return '00/00/0000 00:00:00';
              }

              return parsedDate
                .toLocaleString('es-ES', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                })
                .replace(',', '');
            } catch (error) {
              console.error(
                '❌ ERROR INESPERADO AL PARSEAR FECHA:',
                error,
                data.dt_tracker
              );
              return '00/00/0000 00:00:00';
            }
          })()
        : '00/00/0000 00:00:00';

      let hasPermission = false;
      const permissionList = localStorage.getItem('PermissionList');
      if (permissionList) {
        const content: string[] = JSON.parse(permissionList ?? '[]');
        hasPermission = content.some(
          (permission) => permission === 'vehicle_history'
        );
      }

      let newContent;
      if (nameGroup) {
        newContent =
          '<div class="modern-popup-container">' +
          '<div class="popup-header">' +
          '<div class="vehicle-info">' +
          '<h6 class="vehicle-name" id="vehicle-name-' +
          data.imei +
          '" title="Copiar nombre del vehículo">' +
          data.name +
          '</h6>' +
          '<span class="speed-badge">' +
          data.speed +
          ' km/h</span>' +
          '</div>' +
          '</div>' +
          '<div class="popup-body">' +
          '<div class="group-info">' +
          '<i class="fas fa-layer-group text-muted"></i>' +
          '<span class="group-name">' +
          nameGroup +
          '</span>' +
          '</div>' +
          '<div class="info-grid">' +
          '<div class="info-item">' +
          '<i class="fas fa-user-circle" title="Conductor"></i>' +
          //'<span class="info-label">Conductor:</span>' +
          '<span class="info-value" id="driver-' +
          data.imei +
          '-content">' +
          data.namedriver +
          '</span>' +
          '<button class="copy-btn" id="driver-' +
          data.imei +
          '" title="Copiar conductor">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
          // '<span class="info-label">Ubicación:</span>' +
          '<a href="' +
          googleMapsLink +
          '" target="_blank" class="location-link" id="location-' +
          data.imei +
          '-content">' +
          data.latitud +
          ', ' +
          data.longitud +
          '</a>' +
          '<button class="copy-btn" id="location-' +
          data.imei +
          '" title="Copiar ubicación">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
          // '<span class="info-label">Referencia:</span>' +
          '<span class="info-value" id="reference-' +
          data.imei +
          '-content">' +
          data.ref +
          '</span>' +
          '<button class="copy-btn" id="reference-' +
          data.imei +
          '" title="Copiar referencia">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-clock" title="Transmisión"></i>' +
          // '<span class="info-label">Transmisión:</span>' +
          '<span class="info-value" id="transmission-' +
          data.imei +
          '-content">' +
          dt_tracker +
          '</span>' +
          '<button class="copy-btn" id="transmission-' +
          data.imei +
          '" title="Copiar transmisión">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-pause-circle" title="Tiempo Detenedio"></i>' +
          // '<span class="info-label">T. Detenedio:</span>' +
          '<span class="info-value" id="stoptime-' +
          data.imei +
          '-content">' +
          data.tiempoParada +
          '</span>' +
          '<button class="copy-btn" id="stoptime-' +
          data.imei +
          '" title="Copiar tiempo de parada">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '<div ' +
          (hasPermission ? '' : 'style="display: none;"') +
          ' class="popup-footer">' +
          '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
          data.imei +
          '" id="custom-btn-1-' +
          data.imei +
          '" title="Ver historial del día">' +
          // '<i class="fas fa-history"></i>' +
          '<span>Recorrido hoy</span>' +
          '</button>' +
          '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
          data.imei +
          '" id="custom-btn-2-' +
          data.imei +
          '" title="Crear historial personalizado">' +
          // '<i class="fas fa-cog"></i>' +
          '<span>Elegir fecha</span>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '<style>' +
          '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
          '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
          '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
          '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
          '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
          '.popup-body { padding: 8px 10px; background: white; }' +
          '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
          '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
          '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
          '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
          '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
          '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
          '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
          '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
          '.location-link:hover { text-decoration: underline; }' +
          '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
          '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
          '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
          '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
          '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
          '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
          '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
          '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
          '.btn-modern i { font-size: 10px; }' +
          '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
          '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
          '.copy-btn i { font-size: 10px; }' +
          '</style>';
      } else {
        newContent =
          '<div class="modern-popup-container">' +
          '<div class="popup-header">' +
          '<div class="vehicle-info">' +
          '<h6 class="vehicle-name" id="vehicle-name-' +
          data.imei +
          '" title="Copiar nombre del vehículo">' +
          data.name +
          '</h6>' +
          '<span class="speed-badge">' +
          data.speed +
          ' km/h</span>' +
          '</div>' +
          '</div>' +
          '<div class="popup-body">' +
          '<div class="info-grid">' +
          '<div class="info-item">' +
          '<i class="fas fa-user-circle" title="Conductor"></i>' +
          // '<span class="info-label">Conductor:</span>' +
          '<span class="info-value" id="driver-' +
          data.imei +
          '-content">' +
          data.namedriver +
          '</span>' +
          '<button class="copy-btn" id="driver-' +
          data.imei +
          '" title="Copiar conductor">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
          // '<span class="info-label">Ubicación:</span>' +
          '<a href="' +
          googleMapsLink +
          '" target="_blank" class="location-link" id="location-' +
          data.imei +
          '-content">' +
          data.latitud +
          ', ' +
          data.longitud +
          '</a>' +
          '<button class="copy-btn" id="location-' +
          data.imei +
          '" title="Copiar ubicación">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
          // '<span class="info-label">Referencia:</span>' +
          '<span class="info-value" id="reference-' +
          data.imei +
          '-content">' +
          data.ref +
          '</span>' +
          '<button class="copy-btn" id="reference-' +
          data.imei +
          '" title="Copiar referencia">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-clock" title="Transmisión"></i>' +
          // '<span class="info-label">Transmisión:</span>' +
          '<span class="info-value" id="transmission-' +
          data.imei +
          '-content">' +
          dt_tracker +
          '</span>' +
          '<button class="copy-btn" id="transmission-' +
          data.imei +
          '" title="Copiar transmisión">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '<div class="info-item">' +
          '<i class="fas fa-pause-circle" title="Tiempo Detenido"></i>' +
          // '<span class="info-label">T. Detenido:</span>' +
          '<span class="info-value" id="stoptime-' +
          data.imei +
          '-content">' +
          data.tiempoParada +
          '</span>' +
          '<button class="copy-btn" id="stoptime-' +
          data.imei +
          '" title="Copiar tiempo de parada">' +
          '<i class="fas fa-copy"></i>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '</div>' +
          '<div ' +
          (hasPermission ? '' : 'style="display: none;"') +
          ' class="popup-footer">' +
          '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
          data.imei +
          '" id="custom-btn-1-' +
          data.imei +
          '" title="Ver historial del día">' +
          // '<i class="fas fa-history"></i>' +
          '<span>Recorrido hoy</span>' +
          '</button>' +
          '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
          data.imei +
          '" id="custom-btn-2-' +
          data.imei +
          '" title="Crear historial personalizado">' +
          // '<i class="fas fa-cog"></i>' +
          '<span>Elegir fecha</span>' +
          '</button>' +
          '</div>' +
          '</div>' +
          '<style>' +
          // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
          // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
          // '.leaflet-popup-close-button { display: none !important; }' +
          '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
          '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
          '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
          '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
          '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
          '.popup-body { padding: 8px 10px; background: white; }' +
          '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
          '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
          '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
          '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
          '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
          '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
          '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
          '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
          '.location-link:hover { text-decoration: underline; }' +
          '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
          '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
          '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
          '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
          '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
          '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
          '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
          '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
          '.btn-modern i { font-size: 10px; }' +
          '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
          '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
          '.copy-btn i { font-size: 10px; }' +
          '</style>';
      }
      this.markerClusterGroup.getLayers()[key]['_popup'].setContent(newContent);

      setTimeout(() => {
        const customBtn1 = document.getElementById(
          'custom-btn-1-' + data.imei
        ) as HTMLElement;
        const customBtn2 = document.getElementById(
          'custom-btn-2-' + data.imei
        ) as HTMLElement;

        if (customBtn1) {
          customBtn1.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.onClickHistoryButton.emit({
              is_custom: false,
              imei: data.imei,
            });
            // Cerrar el popup
            this.map.closePopup();
          });
        }

        if (customBtn2) {
          customBtn2.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.onClickHistoryButton.emit({
              is_custom: true,
              imei: data.imei,
            });
            // Cerrar el popup
            this.map.closePopup();
          });
        }

        // Configurar listeners para botones de copiar en la segunda sección
        this.setCopyListener(
          `driver-${data.imei}`,
          data.namedriver,
          `driver-${data.imei}-content`
        );
        this.setCopyListener(
          `location-${data.imei}`,
          `${data.latitud}, ${data.longitud}`,
          `location-${data.imei}-content`
        );
        this.setCopyListener(
          `reference-${data.imei}`,
          data.ref,
          `reference-${data.imei}-content`
        );
        this.setCopyListener(
          `transmission-${data.imei}`,
          dt_tracker,
          `transmission-${data.imei}-content`
        );
        this.setCopyListener(
          `stoptime-${data.imei}`,
          data.tiempoParada,
          `stoptime-${data.imei}-content`
        );
        this.setCopyListener(`vehicle-name-${data.imei}`, data.name);
      }, 100);

      const popupElement = document.getElementsByClassName('btn-history')[0];
      if (popupElement) {
        popupElement.addEventListener('click', () => {
          /*  console.log("Acción ejecutada Calculado en el botón del popup para el vehículo:", data.imei); */
          this.imei.emit(data.imei);
        });
      }
    }
  }

  string_diffechas(a: any, b: any): any {
    let c = Math.floor((b - a) / 1000) % 60;
    let d = Math.floor((b - a) / 60000) % 60;
    let e = Math.floor((b - a) / 3600000) % 24;
    let f = Math.floor((b - a) / 86400000);
    let g = '';
    if (f > 0) {
      g = '' + f + ' d ' + e + ' h ' + d + ' min ' + c + ' s';
    } else if (e > 0) {
      g = '' + e + ' h ' + d + ' min ' + c + ' s';
    } else if (d > 0) {
      g = '' + d + ' min ' + c + ' s';
    } else if (c >= 0) {
      g = '' + c + ' s';
    }
    return g;
  }
  callMethod() {
    console.log('Call Function Every Five Seconds.', new Date());
  }
  async eyeClick(vehicle: UserTracker) {
    //console.log('click eye IMEI = ',IMEI);
    vehicle.eye = !vehicle.eye;
    if (vehicle.eye) {
      // this.markerClusterGroup.addLayer(this.marker[vehicle.IMEI!]);
      await this.drawIcon(vehicle, this.map);
      this.tagClick(vehicle!);
      this.vehicleService.countOpenEyes++;
      this.followClickIcon(this.map, vehicle);
    } else {
      this.markerClusterGroup.removeLayer(this.marker[vehicle.IMEI!]);
      this.vehicleService.countOpenEyes--;
    }
    this.vehicleService.allEyes.state = this.vehicleService.countOpenEyes > 0; //Input EyeAll Update
  }

  async setGroupEyeClick(vehicle: UserTracker, show: boolean) {
    //PARA OCULTAR AGRUPACIONES
    vehicle.eye = show;
    if (vehicle.eye) {
      this.markerClusterGroup.addLayer(this.marker[vehicle.IMEI!]);
      this.tagClick(vehicle!);
      this.vehicleService.countOpenEyes++;
    } else {
      this.markerClusterGroup.removeLayer(this.marker[vehicle.IMEI!]);
      this.vehicleService.countOpenEyes--;
    }
    this.vehicleService.allEyes.state = this.vehicleService.countOpenEyes > 0; //Input EyeAll Update
  }

  // FUNCTION UNUSED
  // eyeClickAll() {
  //   const vehicles = this.vehicleService.vehicles;
  //   for (const i in vehicles) {
  //     // if(vehicles[i].IMEI==IMEI){
  //     vehicles[i].eye = !vehicles[i].eye;
  //     //   vehicle = vehicles[i];
  //     // }
  //     if (vehicles[i].eye == true) {
  //       this.markerClusterGroup.addLayer(this.marker[vehicles[i].IMEI!]);
  //       // this.markerClusterGroupOnda.addLayer(this.markerOnda[vehicles[i].IMEI!]); //Para Ondas
  //       this.tagClick(vehicles[i].IMEI!, false);
  //     } else {
  //       this.markerClusterGroup.removeLayer(this.marker[vehicles[i].IMEI!]);
  //       // this.markerClusterGroupOnda.removeLayer(this.markerOnda[vehicles[i].IMEI!]); //Para Ondas
  //     }
  //   }
  //   this.vehicleService.vehicles = vehicles;
  // }

  async setTag(vehicle: UserTracker) {
    vehicle.tag = !vehicle.tag;
  }

  async tagClick(vehicle: UserTracker) {
    if (vehicle!.tag!) {
      this.marker[vehicle.IMEI!].openTooltip();
    } else {
      this.marker[vehicle.IMEI!].closeTooltip();
    }
  }
  tagDriver(vehicle: UserTracker) {
    vehicle.tag_driver = !vehicle.tag_driver;
    console.log(vehicle);
    const tempNameDriver =
      '<br><span style="display: block; text-align: center;">' +
      vehicle!.namedriver +
      '</span>';
    // Actualizar el contenido del tooltip del marcador específico
    if (vehicle!.tag_driver! && vehicle!.namedriver != 'No Especificado') {
      this.marker[vehicle.IMEI!].setTooltipContent(
        `<span>${vehicle!.name}</span>${tempNameDriver}`
      );
    } else {
      console.log('No tiene driver', vehicle!.namedriver, vehicle!.tag_driver);
      this.marker[vehicle.IMEI!].setTooltipContent(
        `<span>${vehicle!.name}</span>`
      );
    }
  }
  setDefaultName(show_name: string): string {
    if (show_name == 'num_plate') {
      return 'Número de placa';
    } else if (show_name == 'cod_interno') {
      return 'Código interno';
    } else {
      return 'Nombre';
    }
  }
  changeNameVehicles(show_name: string) {
    let vehicle = undefined;
    let tempShowName = '';
    let defaultName = 'Nombre';
    defaultName = this.setDefaultName(show_name);
    for (const i in this.vehicleService.vehicles) {
      vehicle = this.vehicleService.vehicles[i];
      if (show_name == 'num_plate') {
        tempShowName = vehicle!.plate_number!;
      } else if (show_name == 'cod_interno') {
        tempShowName = vehicle!.cod_interno!;
      } else {
        //default name
        tempShowName = vehicle!.name_old!;
      }

      if (tempShowName == null || tempShowName == '') {
        tempShowName = 'Unidad Sin ' + defaultName;
      }

      if (
        vehicle!.tag_driver == true &&
        vehicle!.namedriver != 'No Especificado'
      ) {
        const tempNameDriver =
          '<br><span style="display: block; text-align: center;">' +
          vehicle!.namedriver +
          '</span>';
        this.marker[vehicle!.IMEI!].setTooltipContent(
          `<span>${tempShowName}</span>${tempNameDriver}`
        );
      } else {
        this.marker[vehicle!.IMEI!].setTooltipContent(
          `<span>${tempShowName}</span>`
        );
      }
    }
  }

  async updateNameMarker(vehicle: UserTracker) {
    // console.log('ESTO LLEGO A UPDATE NAME MARKER',vehicle);
    // console.log('ESTO TIENE THIS MARKER',this.marker[vehicle.IMEI!]);

    if (vehicle.eye) {
      // console.log(this.marker[vehicle!.IMEI!].getPopup()['_content']);
      let aux_content = this.marker[vehicle!.IMEI!].getPopup()['_content'];
      let aux_tooltip = this.marker[vehicle!.IMEI!].getTooltip()['_content'];
      let name_old = aux_tooltip.split(/<span[^>]*>|<\/span>/);
      let updatedContent: string = aux_content.replace(
        name_old[1],
        vehicle.name
      );
      this.marker[vehicle!.IMEI!].setPopupContent(updatedContent);
      // console.log(aux_content);
      // console.log(name_old[1]);
      // console.log(updatedContent);
      // console.log(this.marker[vehicle!.IMEI!].getPopup()['_content']);
    }

    if (
      vehicle!.tag_driver == true &&
      vehicle!.namedriver != 'No Especificado'
    ) {
      const tempNameDriver =
        '<br><span style="display: block; text-align: center;">' +
        vehicle!.namedriver +
        '</span>';
      this.marker[vehicle!.IMEI!].setTooltipContent(
        `<span>${vehicle.name}</span>${tempNameDriver}`
      );
    } else {
      this.marker[vehicle!.IMEI!].setTooltipContent(
        `<span>${vehicle.name}</span>`
      );
    }
  }

  async generateContentPopUp(vehicle: any): Promise<string> {
    const googleMapsLink = `https://www.google.com/maps?q=${vehicle.latitud},${vehicle.longitud}`;
    const nameGroup = this.setNameGroup(
      vehicle.nameoperation,
      vehicle.namegrupo,
      vehicle.nameconvoy
    );
    let popupContent =
      '<div class="row"><div class="col-6" align="left"><strong>' +
      vehicle.name +
      '</strong></div><div class="col-6" align="right"><strong class="bg-secondary bg-opacity-25 p-1 rounded ">' +
      vehicle.speed +
      ' km/h</strong></div></div>' +
      '<aside class="">';
    if (nameGroup) {
      popupContent += '<small>' + nameGroup + '</small><br>';
      // console.log('EXISTE nameGroup');
    }
    popupContent +=
      '<span data-bs-toggle="tooltip" data-bs-placement="left" data-bs-title="Conductor 2"><i class="fas fa-user-circle"></i></span> ' +
      vehicle.namedriver +
      '</small><br>' +
      '<small><i class="fas fa-crosshairs"> Ubicacion: </i><a href=" ' +
      googleMapsLink +
      '" target="_blank">' +
      vehicle.latitud +
      ', ' +
      vehicle.longitud +
      '</a></small><br>' +
      // '<small>UBICACION: ' + vehicle.latitud + ', ' + vehicle.longitud + '</small><br>' +
      `<small><i class="fas fa-map-marked-alt"> Referencia: </i> ` +
      vehicle.ref +
      '</small><br>' +
      '<small><i class="fas fa-calendar-alt"> Fecha de Transmision: </i> ' +
      vehicle.dt_tracker +
      '</small><br>' +
      '<small><i class="fas fa-hourglass-half"> Tiempo de Parada: </i> ' +
      vehicle.tiempoParada +
      '</small>' +
      '</aside>';
    return popupContent;
  }
  updateNameDriver(vehicle: any) {
    // console.log('Llego vehicle a map service->', vehicle);
    // console.log('this.Marker', this.marker[vehicle.IMEI]);

    // let auxContentPopUp = this.generateContentPopUp(vehicle);
    //ACTUALIZAR CONTENIDO DEL POPUP DEL ICONO MARKER y EL CLUSTER
    // const markerToUpdate = this.markerClusterGroup.getLayers().find((layer: any) => {
    //   return layer._leaflet_id === this.marker[vehicle.IMEI]._leaflet_id;
    // });
    // console.log('Cluster Group Found ->',markerToUpdate);

    // vehicle.dt_tracker = moment(vehicle.dt_tracker).subtract(5, 'hours').format('YYYY-MM-DD HH:mm:ss');
    vehicle.dt_tracker = this.momentService.toLocal(vehicle.dt_tracker, true);
    let options = {
      imei: vehicle.IMEI,
      name: vehicle.name,
      nameconvoy: vehicle.nameconvoy,
      namegrupo: vehicle.namegrupo,
      nameoperation: vehicle.nameoperation,
      namedriver: vehicle.namedriver,
      longitud: vehicle.longitud.toString(),
      latitud: vehicle.latitud.toString(),
      speed: vehicle.speed,
      dt_tracker: vehicle.dt_tracker, //luego de pasar por filtro
      paradaDesde: '',
      vehicleService: this.vehicleService,
    };
    this.timeStopAux(options);

    // this.marker[vehicle!.IMEI].setPopupContent(auxContentPopUp);

    // markerToUpdate.setPopupContent(auxContentPopUp);
    //ACTUALIZA EL TOOLTIP LOS ACTIVADOS
    if (
      vehicle!.tag_driver == true &&
      vehicle!.namedriver != 'No Especificado'
    ) {
      const tempNameDriver =
        '<br><span style="display: block; text-align: center;">' +
        vehicle!.namedriver +
        '</span>';
      this.marker[vehicle!.IMEI!].setTooltipContent(
        `<span>${vehicle.name}</span>${tempNameDriver}`
      );
    } else {
      this.marker[vehicle!.IMEI!].setTooltipContent(
        `<span>${vehicle.name}</span>`
      );
    }
  }

  async followClickIcon(map: L.Map, vehicle: UserTracker) {
    this.dataFitBounds = [];
    console.log('Click Follow...', vehicle);
    if (vehicle.latitud !== undefined && vehicle.longitud !== undefined) {
      const location = this.marker[vehicle.IMEI!].getLatLng();
      const latitud: number = location.lat;
      const longitud: number = location.lng;
      map.fitBounds([[latitud, longitud]]);
      map.invalidateSize(); // Forzar re-renderizado
    } else {
      console.log('Latitud o Longitud Undefined - ', vehicle.IMEI);
    }
  }

  async setFollowVehicle(vehicle: UserTracker) {
    vehicle.follow = !vehicle.follow;
  }
  async followVehicle(map: any): Promise<void> {
    this.dataFitBounds = [];
    // const vehiclesFollow = await this.filterVehiclesWithFollow();

    const vehiclesFollow = this.vehicleService.vehiclesFollowing;
    if (vehiclesFollow && vehiclesFollow.length > 0) {
      vehiclesFollow.forEach((imei: string) => {
        const aux2: [string, string] = this.marker[imei].getLatLng();
        this.dataFitBounds.push(aux2);
      });
      if (this.dataFitBounds.length > 0) {
        map.fitBounds(this.dataFitBounds);
        map.invalidateSize(); // Forzar re-renderizado
      }
    }
  }

  private async searchVehicleByImei(
    IMEI: string
  ): Promise<UserTracker | undefined> {
    const vehicles = this.vehicleService.vehicles;
    return vehicles.find((vehicle) => vehicle.IMEI == IMEI);
  }

  private async updateVehiclesFollowing(vehicle: UserTracker) {
    // const listFollowing2 = this.vehicleService.vehiclesFollowing.slice(); //COPIAS
    // const listFollowing3 = Array.from(this.vehicleService.vehiclesFollowing); //COPIAS 2
    const index = this.vehicleService.vehiclesFollowing.findIndex(
      (IMEI) => IMEI == vehicle.IMEI
    );

    if (vehicle.follow && index == -1) {
      this.vehicleService.vehiclesFollowing.push(vehicle.IMEI!);
    } else {
      if (index !== -1) {
        this.vehicleService.vehiclesFollowing.splice(index, 1);
      }
    }
    console.log('IMEIFollowing', this.vehicleService.vehiclesFollowing);
  }

  diffSecondsNow(fecha: string): boolean {
    // Obtener la fecha y hora actual
    const fechaActual = this.momentService.get() as moment.Moment;
    // Parsear la fecha proporcionada
    const fechaComparar = this.momentService.toMoment(fecha);
    // Calcular la diferencia en segundos
    const diferenciaEnSegundos = fechaActual.diff(fechaComparar, 'seconds');
    // Comprobar si la diferencia es mayor a 15 segundos
    // console.log('Diff ',diferenciaEnSegundos);
    // console.log('Resulta ',diferenciaEnSegundos>15);
    return diferenciaEnSegundos > 15;
  }

  public async calculateDirection(coord1: any, coord2: any): Promise<string> {
    const angle =
      Math.atan2(coord1.lat - coord2.lat, coord1.lng - coord2.lng) *
      (180 / Math.PI);

    if (angle > -22.5 && angle <= 22.5) return 'right';
    if (angle > 22.5 && angle <= 67.5) return 'upright';
    if (angle > 67.5 && angle <= 112.5) return 'up';
    if (angle > 112.5 && angle <= 157.5) return 'upleft';
    if (angle > 157.5 || angle <= -157.5) return 'left';
    if (angle > -157.5 && angle <= -112.5) return 'downleft';
    if (angle > -112.5 && angle <= -67.5) return 'down';
    if (angle > -67.5 && angle <= -22.5) return 'downright';

    console.log('ERROR NUNCA DEBERIA LLEGAR AQUI');
    return '';
  }

  public async renderVehiclesTransmission() {
    const vehicles = this.vehicleService.vehicles;
    console.log('Rendering transmission icons on map', vehicles);

    for (const vehicle of vehicles) {
      if (!vehicle.IMEI) continue;

      const imei = vehicle.IMEI;
      const direction = vehicle.direction;
      const unit = this.getUnitTransmissionByIMEI(imei);

      let iconUrl = '';

      if (unit) {
        const unitTransmissionId = unit.transmissionStatusId.toString();

        if (unitTransmissionId === vehicle.unitTransmission) {
          continue;
        }

        iconUrl = direction
          ? this.userIconsService.getTransmissionIconDirectionUnsafe(
              unit.unitTypeId,
              unitTransmissionId,
              direction
            )
          : this.userIconsService.getTransmissionIconUnsafe(
              unit.unitTypeId,
              unitTransmissionId
            );

        vehicle.unitTransmission = unitTransmissionId;
      }

      if (!iconUrl) {
        iconUrl = this.userIconsService.getDirectionSvg(
          vehicle.tipo!,
          'default',
          direction
        );
        vehicle.direction = direction;
      }

      const layers = await this.markerClusterGroup.getLayers();
      const marker = this.marker[imei];
      const key = Object.keys(layers).find(
        (k) => layers[k]._leaflet_id === marker['_leaflet_id']
      );

      if (key) {
        const coord = {
          lat: vehicle.latitud,
          lng: vehicle.longitud,
        };

        const currentMarker = layers[key];
        currentMarker.options.icon.options.iconUrl = iconUrl;
        currentMarker.options.icon.options.shadowSize = [30, 30];
        currentMarker.setLatLng(coord);
      }
    }
  }

  async monitor(data: any, map: any): Promise<void> {
    if (this.vehicleService.statusDataVehicle) {
      const vehicles = this.vehicleService.vehicles;

      //console.log('vehicles', vehicles);

      const resultado = vehicles.find(
        (vehi: any) => vehi.IMEI == data.IMEI.toString()
      );
      if (resultado) {
        // update dataCompleted
        // //console.log("update data");
        const index = vehicles.indexOf(resultado);

        const fecha_tracker = this.momentService.toLocal(
          data.fecha_tracker,
          true
        ) as string;
        // const fecha_tracker = moment(data.fecha_tracker)
        //   .subtract(5, 'hours')
        //   .format('YYYY-MM-DD HH:mm:ss');

        // TRAMAS EXCLUIDAS POR VOLCADO
        if (vehicles[index].dt_tracker! > fecha_tracker) {
          // console.log('TRAMA **************************',data.IMEI);
          // console.log('TRAMA dt vehicle:',vehicles[index].dt_tracker);
          // console.log('TRAMA dt (VOLCADO):',fecha_tracker);
          return;
        }

        // LOG Driver ID por IMEI
        // if(data.driver_id != '0' && data.IMEI == '867604055672043'){
        //   console.log('DATA DriverID: ',data.driver_id);
        //   console.log('DATA Vehicle DriverID: ',vehicles[index].driver_id);

        //   console.log('DATA Ftracker: ',fecha_tracker);
        //   console.log('DATA Ftracker: ',vehicles[index].dt_tracker);
        //   console.log('DATA diff: ',this.diffSecondsNow(fecha_tracker));
        // }

        // Fechas Diferentes y Driver ID debe ser diferente para cambiar, la trama debe ser mayor a 15 segundos
        if (
          vehicles[index].dt_tracker != fecha_tracker &&
          vehicles[index].driver_id != data.driver_id
        ) {
          // console.log('Fecha Diferente',vehicles[index].dt_tracker,fecha_tracker);
          // console.log('TRAMA',data);
          vehicles[index].driver_id = data.driver_id;
          // OBTENER EL NOMBRE EN BASE AL ID DRIVER
          vehicles[index].namedriver = this.driversService.getDriverById(
            data.driver_id
          );
          vehicles[index].id_conductor = data.driver_id;
          console.log(
            'DRIVER FOUND ->',
            data.IMEI,
            ' - ',
            data.driver_id,
            ':',
            vehicles[index].namedriver
          );
        }

        vehicles[index].latitud = data.Latitud.toString();
        vehicles[index].longitud = data.Longitud.toString();
        vehicles[index].speed = data.Velocidad;

        vehicles[index].dt_server = data.fecha_server;
        // vehicles[index].dt_tracker = data.fecha_tracker;
        vehicles[index].dt_tracker = fecha_tracker;
        vehicles[index].altitud = data.Altitud;
        vehicles[index].señal_gps = data.señal_gps;
        vehicles[index].señal_gsm = data.señal_gsm;
        vehicles[index].parametros = data.Parametros;
        // const date = moment(vehicles[index].dt_tracker).subtract(5, 'hours');

        vehicles[index] = this.vehicleService.formatVehicle(vehicles[index]);

        // MOSTRAR Ibutton ID de parametrosGet y su IMEI
        // if (
        //   vehicles[index].parametros!.includes('iButton ID=') &&
        //   (vehicles[index].parametrosGet as any)['iButton ID'] !== 0
        // ) {
        // console.log(
        //   'IButton ID:',
        //   (vehicles[index].parametrosGet as any)['iButton ID']
        // );
        // console.log('IMEI:', vehicles[index].IMEI);
        // }
        if (this.imeiPopup == data.IMEI.toString()) {
          let options = {
            imei: data.IMEI,
            name: vehicles[index].name,
            nameconvoy: vehicles[index].nameconvoy,
            namegrupo: vehicles[index].namegrupo,
            nameoperation: vehicles[index].nameoperation,
            namedriver: vehicles[index].namedriver,
            longitud: data.Longitud,
            latitud: data.Latitud,
            speed: data.Velocidad,
            dt_tracker: vehicles[index].dt_tracker, //luego de pasar por filtro
            paradaDesde: '',
            // vehicleService: this.vehicleService,
          };
          this.timeStopAux(options);
        }

        this.vehicleService.vehicles = vehicles;
        if (this.vehicleService.listTable == 0) {
          this.vehicleService.reloadTable.emit();
        } else if (this.vehicleService.listTable == 1) {
          //add register to treetable;
          const tree = this.vehicleService.vehiclesTree;

          // Encuentra la operación en el árbol
          const existingOperation = tree.find(
            (node) => node.data.id === vehicles[index].idoperation
          );
          // console.log('************************************+ ----> ESTE ES EL VEHICULO ',vehicles[index]);

          if (existingOperation) {
            // Encuentra el grupo en la operación
            const existingGroup = existingOperation.children!.find(
              (node) => node.data.id === vehicles[index].idgrupo
            );

            if (existingGroup) {
              // Encuentra el convoy en el grupo
              const existingConvoy = existingGroup.children!.find(
                (node) => node.data.id === vehicles[index].idconvoy
              );

              if (existingConvoy) {
                // Si el convoy existe, actualiza su data con los datos de vehicle[index]
                // console.log('************************************+ ----> ESTE ES EL CONVOY ',existingConvoy);
                // Busca el vehículo dentro de existingConvoy.children
                const existingVehicle = existingConvoy.children!.find(
                  (vehiculo) => vehiculo.data.id === vehicles[index].id
                );

                if (existingVehicle) {
                  // // Aquí puedes actualizar la información del vehículo
                  // console.log('************************************+ ----> ESTE ES EL NAME VEHICLE ',vehicles[index].name);
                  // console.log('************************************+ ----> ESTE ES EL TREE SIN UPDATE ',tree);

                  existingVehicle.data = vehicles[index];

                  // Asigna la estructura de datos modificada a this.vehicleService.vehiclesTree
                  this.vehicleService.vehiclesTree = tree;

                  // Emite el evento para actualizar la vista (si es necesario)
                  this.vehicleService.reloadTableTree.emit();

                  // console.log('************************************+ ----> ESTE ES EL TREE UPDATE ',tree);
                  // Imprime la información actualizada del vehículo
                } else {
                  // El vehículo no se encontró
                  // console.log('Vehículo no encontrado');
                }
              }
            }
          }

          this.vehicleService.reloadTableTree.emit();
        }

        if (vehicles[index].eye) {
          //let onda = this.markerClusterGroupOnda.getLayers();
          let object = await this.markerClusterGroup.getLayers();
          // let oldCoords = this.marker[vehicles[index].IMEI!].getLatLng();

          // PROPUESTA
          let key = Object.keys(object).find(
            (key) =>
              object[key]._leaflet_id ==
              this.marker[vehicles[index].IMEI!]['_leaflet_id']
          );
          if (key != undefined && key) {
            // UPDATE COORDENATE
            let oldCoords = this.markerClusterGroup
              .getLayers()
              [key].getLatLng();
            let coord = {
              lat: vehicles[index].latitud,
              lng: vehicles[index].longitud,
            };

            if (
              this.userDataService.tailActive &&
              vehicles[index].speed != 0 &&
              coord.lat != oldCoords.lat &&
              coord.lng != oldCoords.lng
            ) {
              const imeiX: any = vehicles[index].IMEI;
              this.polylineTail[imeiX].addLatLng([coord.lat, coord.lng]);
              var m = this.polylineTail[imeiX].getLatLngs();
              this.polylineTailTrace[imeiX].setPaths(m);
              // if (m.length > 5) {
              if (m.length > this.userDataService.nroPointsTail) {
                m.shift();
                this.polylineTail[imeiX].setLatLngs(m);
                this.polylineTailTrace[imeiX].setPaths(m);
              }
            }

            if (
              vehicles[index].parametros!.includes('di4=') ||
              vehicles[index].parametros!.includes('Custom_ign=')
            ) {
              // let iconUrl = vehicles[index].custom_svg;

              let iconUrl = this.getIconUrlTransmission(vehicles[index]);

              // let iconUrl = await this.userIconsService.getDirectionSvg(
              //   vehicles[index].tipo!,
              //   'default'
              // );

              if (
                vehicles[index].parametros!.includes('di4=1') ||
                vehicles[index].parametros!.includes('Custom_ign=1')
              ) {
                // VEHICLE LOG ON/OFF
                // this.vehicleService.searchVehicleLog(vehicles[index].vehicle_id!,data.IMEI.toString(),vehicles[index].speed!,vehicles[index].dt_tracker!)

                if (
                  this.userIconsService.changeRotateIcon == true &&
                  this.userIconsService.stateCustomDirectionSvg == true
                ) {
                  this.dif_mayor = 0.0;
                  this.dif_divide = 0.0;
                  this.dif_X = 0.0;
                  this.dif_Y = 0.0;
                  this.direction = '';
                  this.final_direction = '';
                  this.direction_X = '';
                  this.direction_Y = '';

                  if (
                    coord.lat != oldCoords.lat &&
                    coord.lng != oldCoords.lng
                  ) {
                    this.direction = await this.calculateDirection(
                      coord,
                      oldCoords
                    );

                    iconUrl = this.getIconUrlTransmissionDirection(
                      vehicles[index],
                      this.direction
                    );
                    vehicles[index].direction = this.direction;
                    // iconUrl = await this.userIconsService.getDirectionSvg(
                    //   vehicles[index].tipo!,
                    //   'default',
                    //   this.direction
                    // );
                  }
                }

                // if (
                //   this.userDataService.tailActive &&
                //   coord.lat != oldCoords.lat &&
                //   coord.lng != oldCoords.lng
                // ) {
                //   const imeiX: any = vehicles[index].IMEI;
                //   this.polylineTail[imeiX].addLatLng([coord.lat, coord.lng]);
                //   var m = this.polylineTail[imeiX].getLatLngs();
                //   this.polylineTailTrace[imeiX].setPaths(m);
                //   // if (m.length > 5) {
                //   if (m.length > this.userDataService.nroPointsTail) {
                //     m.shift();
                //     this.polylineTail[imeiX].setLatLngs(m);
                //     this.polylineTailTrace[imeiX].setPaths(m);
                //   }
                // }

                if (this.userIconsService.changeItemIcon == ItemIcon.VEHICLES) {
                  if (
                    this.userIconsService.changeRotateIcon == true &&
                    this.userIconsService.stateVehiclesDirectionSvg == true
                  ) {
                    this.dif_mayor = 0.0;
                    this.dif_divide = 0.0;
                    this.dif_X = 0.0;
                    this.dif_Y = 0.0;
                    this.direction = '';
                    this.final_direction = '';
                    this.direction_X = '';
                    this.direction_Y = '';

                    if (
                      coord.lat != oldCoords.lat &&
                      coord.lng != oldCoords.lng
                    ) {
                      this.direction = await this.calculateDirection(
                        coord,
                        oldCoords
                      );

                      iconUrl = this.getIconUrlTransmissionDirection(
                        vehicles[index],
                        this.direction
                      );
                      vehicles[index].direction = this.direction;

                      // let state = this.getStateVehicle(vehicles[index]);
                      // iconUrl = await this.userIconsService.getDirectionSvg(
                      //   vehicles[index].tipo!,
                      //   state,
                      //   this.direction
                      // );
                    }
                  } else {
                    iconUrl = this.getIconUrlTransmission(vehicles[index]);

                    // let state = this.getStateVehicle(vehicles[index]);
                    // iconUrl = await this.userIconsService.getDirectionSvg(
                    //   vehicles[index].tipo!,
                    //   state
                    // );
                  }
                } else if (
                  this.userIconsService.changeItemIcon == ItemIcon.ONDAS
                ) {
                  let iconUrl2 = await this.getUrlByStateOndas(vehicles[index]);
                  this.markerClusterGroupOnda.getLayers()[key]['options'][
                    'icon'
                  ]['options']['iconUrl'] = iconUrl2;
                  this.markerClusterGroupOnda.getLayers()[key].setLatLng(coord);
                }

                if (vehicles[index].speed != 0) {
                  //ESTA EN MOVIMIENTO

                  this.dif_mayor = 0.0;
                  this.dif_divide = 0.0;
                  this.dif_X = 0.0;
                  this.dif_Y = 0.0;
                  this.direction = '';
                  this.final_direction = '';
                  this.direction_X = '';
                  this.direction_Y = '';

                  if (
                    coord.lat != oldCoords.lat &&
                    coord.lng != oldCoords.lng
                  ) {
                    if (coord.lat! > oldCoords.lat) {
                      //arriba
                      this.direction_Y = 'up';
                      this.dif_Y = parseFloat(coord.lat!) - oldCoords.lat;
                      //console.log("dif_Y",this.dif_Y)
                      if (this.dif_Y >= this.dif_mayor) {
                        this.dif_mayor = this.dif_Y;
                        this.direction = 'up';
                        this.dif_divide = this.dif_Y / 2;
                      }
                    } else {
                      //abajo
                      this.direction_Y = 'down';
                      this.dif_Y = oldCoords.lat - parseFloat(coord.lat!);
                      if (this.dif_Y >= this.dif_mayor) {
                        this.dif_mayor = this.dif_Y;
                        this.direction = 'down';
                        this.dif_divide = this.dif_Y / 2;
                      }
                    }

                    if (coord.lng! > oldCoords.lng) {
                      //derecha
                      this.direction_X = 'right';
                      this.dif_X = parseFloat(coord.lng!) - oldCoords.lng;
                      if (this.dif_X >= this.dif_mayor) {
                        this.dif_mayor = this.dif_X;
                        this.direction = 'right';
                        this.dif_divide = this.dif_X / 2;
                      }
                    } else {
                      //izquierda
                      this.direction_X = 'left';
                      this.dif_X = oldCoords.lng - parseFloat(coord.lng!);
                      if (this.dif_X >= this.dif_mayor) {
                        this.dif_mayor = this.dif_X;
                        this.direction = 'left';
                        this.dif_divide = this.dif_X / 2;
                      }
                    }

                    if (this.direction == 'up' || this.direction == 'down') {
                      if (this.dif_X >= this.dif_divide) {
                        this.final_direction = `${this.direction}-${this.direction_X}`;
                      } else {
                        this.final_direction = `${this.direction}`;
                      }
                    } else {
                      if (this.dif_Y >= this.dif_divide) {
                        this.final_direction = `${this.direction_Y}-${this.direction}`;
                      } else {
                        this.final_direction = `${this.direction}`;
                      }
                    }

                    //this.changePositionArrow(this.final_direction,key);
                    if (
                      this.userIconsService.changeItemIcon == ItemIcon.CURSOR &&
                      vehicles[index].speed! > vehicles[index].limit_speed!
                    ) {
                      this.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options'][
                        'shadowUrl'
                      ] = `./assets/images/excessCursor/arrow_${this.final_direction}.webp`;
                      this.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowAnchor'] = [14, 60];
                    } else {
                      this.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options'][
                        'shadowUrl'
                      ] = `./assets/images/arrow_${this.final_direction}.webp`;
                      this.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowAnchor'] = [14, 60];
                    }
                  } else {
                    if (
                      this.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowUrl']
                    ) {
                      let old_direction = this.markerClusterGroup
                        .getLayers()
                        [key]['options']['icon']['options']['shadowUrl'].split(
                          '_'
                        );
                      //this.changePositionArrow(old_direction[1],key);
                      if (
                        this.userIconsService.changeItemIcon ==
                          ItemIcon.CURSOR &&
                        vehicles[index].speed! > vehicles[index].limit_speed!
                      ) {
                        this.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options'][
                          'shadowUrl'
                        ] = `./assets/images/excessCursor/arrow_${old_direction[1]}`;
                        this.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options']['shadowAnchor'] = [14, 60];
                      } else {
                        this.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options'][
                          'shadowUrl'
                        ] = `./assets/images/arrow_${old_direction[1]}`;
                        this.markerClusterGroup.getLayers()[key]['options'][
                          'icon'
                        ]['options']['shadowAnchor'] = [14, 60];
                      }
                    } else {
                      this.markerClusterGroup.getLayers()[key]['options'][
                        'icon'
                      ]['options']['shadowUrl'] = '';
                      //console.log('se borra la flecha', vehicles[index].name);
                      //console.log(vehicles[index].name);
                    }
                  }
                } else if (
                  this.userIconsService.changeItemIcon == ItemIcon.CURSOR &&
                  vehicles[index].speed == 0
                ) {
                  if (
                    this.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ]['shadowUrl']
                  ) {
                    let old_direction = this.markerClusterGroup
                      .getLayers()
                      [key]['options']['icon']['options']['shadowUrl'].split(
                        '_'
                      );
                    this.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ][
                      'shadowUrl'
                    ] = `./assets/images/relentiCursor/arrow_${old_direction[1]}`;
                    this.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ]['shadowAnchor'] = [14, 60];
                  } else {
                    this.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ][
                      'shadowUrl'
                    ] = `./assets/images/relentiCursor/arrow_down-left.webp`;
                    this.markerClusterGroup.getLayers()[key]['options']['icon'][
                      'options'
                    ]['shadowAnchor'] = [14, 60];
                  }
                } else {
                  this.markerClusterGroup.getLayers()[key]['options']['icon'][
                    'options'
                  ]['shadowUrl'] = '';
                }

                this.markerClusterGroup.getLayers()[key]['options']['icon'][
                  'options'
                ]['iconUrl'] = iconUrl;
                this.markerClusterGroup.getLayers()[key]['options']['icon'][
                  'options'
                ]['shadowSize'] = [30, 30];
              } else {
                // REMOVER CURSOR SI EXISTE
                // if(this.markerClusterGroup.getLayers()[key]['options']['icon']['options']['shadowUrl']){
                //   console.log('Remover Cursor',vehicles[index].IMEI);
                //   this.markerClusterGroup.getLayers()[key]['options']['icon']['options']['shadowUrl'] = '';
                // }
              }

              this.timeChangeIconUrl(
                vehicles[index].IMEI!,
                vehicles[index].tipo!,
                key
              );
              const googleMapsLink = `https://www.google.com/maps?q=${vehicles[index].latitud},${vehicles[index].longitud}`;
              const nameGroup = this.setNameGroup(
                vehicles[index].nameoperation!,
                vehicles[index].namegrupo!,
                vehicles[index].nameconvoy!
              );
              if (nameGroup) {
                this.markerClusterGroup.getLayers()[key]['_popup']['_content'] =
                  '<div class="modern-popup-container">' +
                  '<div class="popup-header">' +
                  '<div class="vehicle-info">' +
                  '<h6 class="vehicle-name">' +
                  vehicles[index].name +
                  '</h6>' +
                  '<span class="speed-badge">' +
                  vehicles[index].speed +
                  ' km/h</span>' +
                  '</div>' +
                  '</div>' +
                  '<div class="popup-body">' +
                  '<div class="group-info">' +
                  '<i class="fas fa-layer-group text-muted"></i>' +
                  '<span class="group-name">' +
                  nameGroup +
                  '</span>' +
                  '</div>' +
                  '<div class="info-grid">' +
                  '<div class="info-item">' +
                  '<i class="fas fa-user-circle" title="Conductor"></i>' +
                  '<span class="info-value">' +
                  vehicles[index].namedriver +
                  '</span>' +
                  '<button class="copy-btn" title="Copiar conductor">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
                  '<a href="' +
                  googleMapsLink +
                  '" target="_blank" class="location-link">' +
                  vehicles[index].latitud +
                  ', ' +
                  vehicles[index].longitud +
                  '</a>' +
                  '<button class="copy-btn" title="Copiar ubicación">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
                  '<span class="info-value">Calculando ...</span>' +
                  '<button class="copy-btn" title="Copiar referencia">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-clock" title="Transmisión"></i>' +
                  '<span class="info-value">' +
                  vehicles[index].dt_tracker +
                  '</span>' +
                  '<button class="copy-btn" title="Copiar transmisión">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-pause-circle" title="Tiempo Detenido"></i>' +
                  '<span class="info-value">Calculando ...</span>' +
                  '<button class="copy-btn" title="Copiar tiempo de parada">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '</div>' +
                  '</div>' +
                  '</div>' +
                  '<style>' +
                  // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
                  // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
                  // '.leaflet-popup-close-button { display: none !important; }' +
                  '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
                  '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
                  '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
                  '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
                  '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
                  '.popup-body { padding: 8px 10px; background: white; }' +
                  '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
                  '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
                  '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
                  '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
                  '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
                  '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
                  '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
                  '.location-link:hover { text-decoration: underline; }' +
                  '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
                  '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
                  '.copy-btn i { font-size: 10px; }' +
                  '</style>';
              } else {
                this.markerClusterGroup.getLayers()[key]['_popup']['_content'] =
                  '<div class="modern-popup-container">' +
                  '<div class="popup-header">' +
                  '<div class="vehicle-info">' +
                  '<h6 class="vehicle-name">' +
                  vehicles[index].name +
                  '</h6>' +
                  '<span class="speed-badge">' +
                  vehicles[index].speed +
                  ' km/h</span>' +
                  '</div>' +
                  '</div>' +
                  '<div class="popup-body">' +
                  '<div class="info-grid">' +
                  '<div class="info-item">' +
                  '<i class="fas fa-user-circle" title="Conductor"></i>' +
                  '<span class="info-value">' +
                  vehicles[index].namedriver +
                  '</span>' +
                  '<button class="copy-btn" title="Copiar conductor">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
                  '<a href="' +
                  googleMapsLink +
                  '" target="_blank" class="location-link">' +
                  vehicles[index].latitud +
                  ', ' +
                  vehicles[index].longitud +
                  '</a>' +
                  '<button class="copy-btn" title="Copiar ubicación">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
                  '<span class="info-value">Calculando ...</span>' +
                  '<button class="copy-btn" title="Copiar referencia">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-clock" title="Transmisión"></i>' +
                  '<span class="info-value">' +
                  vehicles[index].dt_tracker +
                  '</span>' +
                  '<button class="copy-btn" title="Copiar transmisión">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '<div class="info-item">' +
                  '<i class="fas fa-pause-circle" title="Tiempo Detenido"></i>' +
                  '<span class="info-value">Calculando ...</span>' +
                  '<button class="copy-btn" title="Copiar tiempo de parada">' +
                  '<i class="fas fa-copy"></i>' +
                  '</button>' +
                  '</div>' +
                  '</div>' +
                  '</div>' +
                  '</div>' +
                  '<style>' +
                  // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
                  // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
                  // '.leaflet-popup-close-button { display: none !important; }' +
                  '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
                  '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
                  '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
                  '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
                  '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
                  '.popup-body { padding: 8px 10px; background: white; }' +
                  '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
                  '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
                  '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
                  '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
                  '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
                  '.location-link:hover { text-decoration: underline; }' +
                  '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
                  '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
                  '.copy-btn i { font-size: 10px; }' +
                  '</style>';
              }
            } else {
              // console.log('TRAMA IGNORADA NO CAMBIA ESTADO VEHICULO ----->',vehicles[index].IMEI);
            }
            this.markerClusterGroup.getLayers()[key].setLatLng(coord);
            this.followVehicle(this.map);
          }
        }
      } //end if index vehicle
    }
  }

  private renderAllVehicleIcons() {}

  private getUnitTransmissionByIMEI(
    imei: string
  ): UnitWithTransmissionStatus | null {
    const unit = this.units.find((unit) => unit.device.IMEI === imei);
    if (
      !unit ||
      unit.transmissionStatusId === undefined ||
      unit.transmissionStatusId === null
    ) {
      return null;
    }
    return unit;
  }

  changeStatusEye(id: number): void {
    this.changeEye.emit(id);
  }

  sendDataMap(data: Vehicle[]): void {
    this.sendData.emit(data);
  }

  loadMap(map: any): void {
    // //console.log("loadMap");
    this.map = map;
  }

  changePositionArrow(direction: string, key: any) {
    switch (direction) {
      case 'up':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [14, 60];
        break;
      case 'up-left':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [50, 60];
        break;
      case 'up-right':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [-20, 60];
        break;
      case 'down':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [13, 0];
        break;
      case 'down-left':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [13, 30];
        break;
      case 'down-right':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [13, 30];
        break;
      case 'left':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [50, 30];
        break;
      case 'right':
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowAnchor'
        ] = [-20, 30];
        break;
    }
  }

  // deleteMarker(IMEI: string):void{
  //   this.map.removeLayer(this.marker[IMEI]);
  // }

  onDrawIcon(map: any): void {
    this.map = map;
    let group: any[] = [];
    const e = this.vehicleService.vehicles;
    let aux_cont = 0;
    console.log(e, 'render map icons ');
    const transmissionStatusColor: any = {
      10: 'green',
      20: 'blue',
      30: 'purple',
      40: 'black',
      50: 'orange',
      60: 'red',
      100: 'transm-color-not-defined',
    };

    this.markerClusterGroup.clearLayers();
    this.markerClusterGroupOnda.clearLayers();
    for (const property in e) {
      //console.log("e----- ", property);
      //console.log("e.hasOwnProperty(property)", e.hasOwnProperty(property));
      //console.log("e[property].eye", e[property].eye);
      if (e.hasOwnProperty(property) && e[property].eye == true) {
        if (this.statusMap == false) {
          const aux2: [string, string] = [
            e[property].latitud!,
            e[property].longitud!,
          ];
          this.dataFitBounds.push(aux2);
        }
        // this.map.removeLayer(this.demo);
        // this.drawIcon(e[property], map, Number(e[property].latitud), Number(e[property].longitud));
        this.drawIcon(e[property], map);
      }
    }

    if (this.dataFitBounds.length > 0) {
      // //console.log("dataFitBounds map",this.dataFitBounds);
      map.fitBounds(this.dataFitBounds);
    }
    this.statusMap = true;
    this.dataFitBounds = [];
    //EVENTO cluster lista
    this.markerClusterGroup.on('clusterclick', function (a: any) {
      // console.log('click cluster...........');
      var coords = a.layer.getLatLng();
      //console.log(a.layer.getAllChildMarkers());
      var lista = '<table class="infovehiculos"><tbody>';
      var array = a.layer.getAllChildMarkers();
      // console.log('array',array);
      for (const i in array) {
        var aaa = array[i]['_tooltip']['_content'];
        //console.log(aaa.replace(/<\/?[^>]+(>|$)/g, ""));
        var vehicleData = e.find(
          (vehicle: UserTracker) =>
            vehicle.name == aaa.replace(/<\/?[^>]+(>|$)/g, '')
        );
        var transmissionColorClass =
          typeof vehicleData != 'undefined'
            ? transmissionStatusColor[vehicleData.point_color!]
            : 'transm-color-not-defined';
        lista =
          lista +
          '<tr><td><div class="dot-vehicle ' +
          transmissionColorClass +
          '"></div></td><td>' +
          aaa +
          '</td></tr>';
      }
      // for (var i=0; i<array.length; i++){
      //     var aaa = array[i].label._content.split(' <');
      //     // //console.log(aaa[0]);
      //     var bbb = array[i].label._content.split('color:');
      //     var ccc = bbb[1].split(';');
      //     //console.log(aaa[0]+" - color css : "+ccc[0]);
      //     lista = lista + '<tr style="margin:10px;"><td><div style="border-radius: 50%; width: 10px; height: 10px; background-color:' + ccc[0] + ';"></div></td><td style="font-size: 14px;">' + aaa[0] + '</td></tr>';
      // }
      lista = lista + '</tbody></table>';
      var popupMarker = L.popup({
        maxHeight: 400,
        closeButton: false,
        closeOnClick: true,
        autoClose: true,
        className: 'popupList',
      })
        .setLatLng([coords.lat, coords.lng])
        .setContent(lista)
        .openOn(map);
    });
  }
  // private
  private groupAllv2(distance: number): any {
    const e = this.vehicleService.vehicles;
    let group: any[] = [];
    let d = distance * -1;

    let i_group = 0;
    for (const index in e) {
      let i = parseInt(index);
      // group[i]={
      //   name:e[i].name,
      //   distance:0,
      //   data:[]
      // };
      // get x , y
      let x = Math.trunc(parseInt(e[i].longitud!) / d) * d + d;
      // //console.log('longitud vehicle ',e[i].longitud);
      // //console.log('longitud x', x);
      let y = Math.trunc(parseInt(e[i].latitud!) / d) * d + d;
      // //console.log('latitud vehicle ',e[i].latitud);
      // //console.log('latitud y', y);

      let status = true;
      for (const index2 in group) {
        let j = parseInt(index2);

        if (group[j]['long'] == x && group[j]['lat']) {
          group[j]['data'].push(e[i]);
          status = false;
        }
      }

      if (status) {
        //crate new group
        group[i_group] = {
          name: i_group + 1,
          long: x,
          lat: y,
          longitud: x + (d / 2) * -1,
          latitud: y + (d / 2) * -1,
          data: [],
        };
        group[i_group].data.push(e[i]);
        //console.log('create new group',i_group);
        i_group++;
      }
    }
    return group;
  }

  private mensaje() {
    //console.log("mensaje");
  }
  public timeStopAux(data: any): void {
    // console.log("calculando time stop aux ... ",data.name);

    let ar_vel = data.speed;
    if (data.speed > 3) {
      ar_vel = data.speed;
      data.paradaDesde = false;
    } else {
      if (data.paradaDesde == false) {
        ar_vel = data.speed;
      } else {
        ar_vel = -1; // velocidad mayor a 6 para que no traiga historial
      }
    }
    // let f_ini = moment(new Date())
    //   .add(-1, 'days')
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');
    // let f_fin = moment(new Date())
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');
    let f_ini = this.momentService.getDateUTCWithOptions(
      -1,
      'days',
      'YYYY-MM-DD HH:mm:ss'
    );
    let f_fin = this.momentService.getDateUTCWithOptions(
      undefined,
      undefined,
      'YYYY-MM-DD HH:mm:ss'
    );

    let params = {
      imei: data.imei,
      name: data.name,
      nameconvoy: data.nameconvoy,
      namegrupo: data.namegrupo,
      nameoperation: data.nameoperation,
      namedriver: data.namedriver,
      longitud: data.longitud,
      latitud: data.latitud,
      speed: data.speed,
      dt_tracker: data.dt_tracker,
      paradaDesde: data.paradaDesde,
      fecha_i: f_ini,
      fecha_f: f_fin,
      vel: ar_vel,
    };

    this.vehicleService.postTimeStop(params);
  }
  //CUANDO SE HACE CLICK EN UN VEHICLE
  public timeStop = (vhDataDefault: any): void => {
    // console.log("this",vhDataDefault);
    // console.log(this.marker[vhDataDefault.imei].getPopup()['_content']);
    // consultar data actual
    // let vehicle = this.vehicleService.getVehicle(this.imei);
    let vehicle = this.vehicleService.getVehicle(vhDataDefault.imei);
    // console.log('Click Vehicle ->',vehicle);
    // console.log("this -> ",vhDataDefault);
    vhDataDefault.speed = vehicle.speed;
    vhDataDefault.dt_tracker = vehicle.dt_tracker;
    vhDataDefault.longitud = vehicle.longitud;
    vhDataDefault.latitud = vehicle.latitud;

    // console.log("calculando time stop ...");

    let ar_vel = vhDataDefault.speed;
    if (vhDataDefault.speed > 3) {
      ar_vel = vhDataDefault.speed;
      vhDataDefault.paradaDesde = false;
    } else {
      if (vhDataDefault.paradaDesde == false) {
        ar_vel = vhDataDefault.speed;
      } else {
        ar_vel = -1; // velocidad mayor a 6 para que no traiga historial
      }
    }

    // let f_ini = moment(new Date())
    //   .add(-1, 'days')
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');
    // let f_fin = moment(new Date())
    //   .add(5, 'hours')
    //   .format('YYYY-MM-DD HH:mm:ss');
    let f_ini = this.momentService.getDateUTCWithOptions(
      -1,
      'days',
      'YYYY-MM-DD HH:mm:ss'
    );
    let f_fin = this.momentService.getDateUTCWithOptions(
      undefined,
      undefined,
      'YYYY-MM-DD HH:mm:ss'
    );

    let params = {
      imei: vhDataDefault.imei,
      name: vehicle.name,
      nameconvoy: vehicle.nameconvoy,
      namegrupo: vehicle.namegrupo,
      nameoperation: vehicle.nameoperation,
      namedriver: vehicle.namedriver,
      longitud: vhDataDefault.longitud,
      latitud: vhDataDefault.latitud,
      speed: vhDataDefault.speed,
      dt_tracker: vhDataDefault.dt_tracker,
      paradaDesde: vhDataDefault.paradaDesde,
      fecha_i: f_ini,
      fecha_f: f_fin,
      vel: ar_vel,
    };
    this.vehicleService.postTimeStop(params);
  };

  public getStateVehicle(vehicle: UserTracker): string {
    //console.log("vehicle",vehicle)
    if (vehicle.speed != 0 && vehicle.speed! < vehicle.limit_speed!) {
      return 'movement';
    } else if (vehicle.speed == 0) {
      return 'relenti';
    } else if (vehicle.speed != 0 && vehicle.speed! > vehicle.limit_speed!) {
      return 'excess';
    }
    return 'default';
  }

  public async getUrlByStateOndas(data: any): Promise<string> {
    //console.log('detsateondas', data);
    // if (
    //   data.parametros!.includes('di4=1') ||
    //   data.parametros!.includes('Custom_ign=1')
    // ) {
    //   if (data?.speed != 0 && data?.speed! < data?.limit_speed!) {
    //    //console.log('velocidad < 90', data?.speed);
    //     //console.log('velocidad < 90 IMEI', data?.IMEI);
    //     return './assets/images/objects/nuevo/gif/onda_verde.gif';
    //   } else if (data?.speed != 0 && data?.speed! > data?.limit_speed!) {
    //     //console.log('velocidad > 90', data?.speed);
    //     return './assets/images/objects/nuevo/gif/onda_roja.gif';
    //   } else if (data?.speed == 0) {
    //     //console.log('velocidad == 0 ', data?.speed);
    //     return './assets/images/objects/nuevo/gif/onda_azul.gif';
    //   } else {
    //     return './assets/images/objects/nuevo/gif/blanco.png';
    //   }
    // }
    // return './assets/images/objects/nuevo/gif/blanco.png';

    if (data?.speed != 0 && data?.speed! < data?.limit_speed!) {
      return './assets/images/objects/nuevo/gif/onda_verde.gif';
    } else if (data?.speed != 0 && data?.speed! > data?.limit_speed!) {
      return './assets/images/objects/nuevo/gif/onda_roja.gif';
    } else if (data?.speed == 0) {
      return './assets/images/objects/nuevo/gif/onda_azul.gif';
    } else {
      return './assets/images/objects/nuevo/gif/blanco.png';
    }
  }

  private async drawIcon(data: any, map: any): Promise<void> {
    // let iconUrl;
    // iconUrl = await this.userIconsService.getDirectionSvg(
    //   data.tipo!,
    //   'default'
    // );
    let iconUrl = this.getIconUrlTransmission(data);

    if (this.userIconsService.changeItemIcon == ItemIcon.ONDAS) {
      // let iconUrl2 = await this.getUrlByStateOndas(data); //ANTEs
      let iconUrl2 = './assets/images/objects/nuevo/gif/blanco.png';
      if (await this.hasParamIgnition(data)) {
        if (await this.checkParamIgnition(data)) {
          iconUrl2 = await this.setIconUrlOndaByState(data);
        }
      }
      const myIcono = L.icon({
        iconUrl: iconUrl2,
        iconSize: [60, 60],
        iconAnchor: [33, 43],
      });

      const tempMarker1 = L.marker([data.latitud, data.longitud], {
        icon: myIcono,
      }).setZIndexOffset(-1);
      this.markerOnda[data.IMEI] = tempMarker1;
      this.markerClusterGroupOnda.addLayer(tempMarker1);
      this.markerClusterGroupOnda.addTo(this.map);
    }

    if (this.userDataService.tailActive) {
      if (
        this.polylineTail[data.IMEI] === undefined ||
        this.polylineTail[data.IMEI] === null
      ) {
        // if (typeof this.polylineTail[data.IMEI] != "undefined") {
        const opcionesLineaTail = {
          color: '#00d425',
          weight: 3,
          opacity: 1.0,
        };
        const tempLineaTail = L.polyline([], opcionesLineaTail);

        this.polylineTail[data.IMEI] = tempLineaTail;
        this.polylineTail[data.IMEI].addTo(this.map);
        // this.polylineClusterGroupTail.addLayer(tempLineaTail);
        // this.polylineClusterGroupTail.addTo(this.map);
      } else {
        this.polylineTail[data.IMEI].setLatLngs([]);
        this.polylineTail[data.IMEI].addTo(this.map);
      }

      //==============================================================================
      if (
        this.polylineTailTrace[data.IMEI] === undefined ||
        this.polylineTailTrace[data.IMEI] === null
      ) {
        // if (typeof this.polylineTailTrace[data.IMEI] != "undefined" && ) {
        // console.log("VACIO 0");
        // console.log(this.polylineTailTrace[data.IMEI]);

        const optionsLineTailTrace = {
          patterns: [
            {
              offset: 0,
              repeat: 20,
              symbol: L.Symbol.arrowHead({
                pixelSize: 7,
                polygon: true,
                pathOptions: {
                  stroke: true,
                  weight: 1,

                  color: '#00d425',
                  opacity: 1,

                  fillColor: 'white',
                  fillOpacity: 1,
                },
              }),
            },
          ],
        };
        const tempLineaTrace = L.polylineDecorator([], optionsLineTailTrace);

        this.polylineTailTrace[data.IMEI] = tempLineaTrace;
        this.polylineTailTrace[data.IMEI].addTo(this.map);
      } else {
        // console.log("LLENADO 0 path");
        // console.log(this.polylineTailTrace[data.IMEI]);

        this.polylineTailTrace[data.IMEI].setPaths([]);
        this.polylineTailTrace[data.IMEI].addTo(this.map);
      }
    } else {
      if (
        this.polylineTail[data.IMEI] === undefined ||
        this.polylineTail[data.IMEI] === null
      ) {
        //nada
      } else {
        this.polylineTail[data.IMEI].setLatLngs([]);
        this.map.removeLayer(this.polylineTail[data.IMEI]);
      }

      if (
        this.polylineTailTrace[data.IMEI] === undefined ||
        this.polylineTailTrace[data.IMEI] === null
      ) {
        //nada
        // console.log("active:false  ==>  nada");
      } else {
        // console.log("active:false  ==>  remover TailTrace");
        this.polylineTailTrace[data.IMEI].setPaths([]);
        this.map.removeLayer(this.polylineTailTrace[data.IMEI]);
      }
    }
    //==================== fin tailActive ===========================

    const iconMarker = L.icon({
      iconUrl: iconUrl,
      iconSize: [55, 55],
      iconAnchor: [30, 45],
      popupAnchor: [-3, -40],
    });

    let nameGroup = this.setNameGroup(
      data.nameoperation,
      data.namegrupo,
      data.nameconvoy
    );
    const googleMapsLink = `https://www.google.com/maps?q=${data.latitud},${data.longitud}`;
    const dt_tracker = data.dt_tracker
      ? (() => {
          try {
            const dateStr = data.dt_tracker.toString().trim();

            // Normalizar AM/PM con espacios flexibles
            let normalizedDateStr = dateStr
              .replace(/p\.\s*m\./gi, 'PM')
              .replace(/a\.\s*m\./gi, 'AM')
              .replace(/\s+/g, ' '); // Normalizar espacios múltiples

            // Regex más flexible para diferentes formatos
            const dateTimeMatch = normalizedDateStr.match(
              /(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4}),?\s*(.+)/
            );

            if (dateTimeMatch) {
              const [, day, month, year, time] = dateTimeMatch;
              normalizedDateStr = `${month}/${day}/${year} ${time}`;
            }

            const parsedDate = new Date(normalizedDateStr);

            if (isNaN(parsedDate.getTime())) {
              console.error('(MAP) ERROR AL PARSEAR FECHA:', {
                original: dateStr,
                normalized: normalizedDateStr,
                parsedDate: parsedDate,
                getTime: parsedDate.getTime(),
              });
              return '00/00/0000 00:00:00';
            }

            return parsedDate
              .toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
              })
              .replace(',', '');
          } catch (error) {
            console.error(
              '❌ ERROR INESPERADO AL PARSEAR FECHA:',
              error,
              data.dt_tracker
            );
            return '00/00/0000 00:00:00';
          }
        })()
      : '00/00/0000 00:00:00';

    let hasPermission = false;
    const permissionList = localStorage.getItem('PermissionList');
    if (permissionList) {
      const content: string[] = JSON.parse(permissionList ?? '[]');
      hasPermission = content.some(
        (permission) => permission === 'vehicle_history'
      );
    }

    let popupText;
    if (nameGroup) {
      popupText =
        '<div class="modern-popup-container">' +
        '<div class="popup-header">' +
        '<div class="vehicle-info">' +
        '<h6 class="vehicle-name" id="vehicle-name-' +
        data.IMEI +
        '" title="Copiar nombre del vehículo">' +
        data.name +
        '</h6>' +
        '<span class="speed-badge">' +
        data.speed +
        ' km/h</span>' +
        '</div>' +
        '</div>' +
        '<div class="popup-body">' +
        '<div class="group-info">' +
        '<i class="fas fa-layer-group text-muted"></i>' +
        '<span class="group-name">' +
        nameGroup +
        '</span>' +
        '</div>' +
        '<div class="info-grid">' +
        '<div class="info-item">' +
        '<i class="fas fa-user-circle" title="Conductor"></i>' +
        // '<span class="info-label">Conductor:</span>' +
        '<span class="info-value" id="driver-' +
        data.IMEI +
        '-content">' +
        data.namedriver +
        '</span>' +
        '<button class="copy-btn" id="driver-' +
        data.IMEI +
        '" title="Copiar conductor">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marker-alt" title="Ubicación"></i>' +
        // '<span class="info-label">Ubicación:</span>' +
        '<a href="' +
        googleMapsLink +
        '" target="_blank" class="location-link" id="location-' +
        data.IMEI +
        '-content">' +
        data.latitud +
        ', ' +
        data.longitud +
        '</a>' +
        '<button class="copy-btn" id="location-' +
        data.IMEI +
        '" title="Copiar ubicación">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marked-alt" title="Referencia"></i>' +
        // '<span class="info-label">Referencia:</span>' +
        '<span class="info-value" id="reference-' +
        data.IMEI +
        '-content">NN</span>' +
        '<button class="copy-btn" id="reference-' +
        data.IMEI +
        '" title="Copiar referencia">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-clock" title="Transmisión"></i>' +
        // '<span class="info-label">Transmisión:</span>' +
        '<span class="info-value" id="transmission-' +
        data.IMEI +
        '-content">' +
        dt_tracker +
        '</span>' +
        '<button class="copy-btn" id="transmission-' +
        data.IMEI +
        '" title="Copiar transmisión">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-pause-circle" title="Tiempo Detenido"></i>' +
        // '<span class="info-label">T. Detenido:</span>' +
        '<span class="info-value" id="stoptime-' +
        data.IMEI +
        '-content">' +
        this.time_stop +
        '</span>' +
        '<button class="copy-btn" id="stoptime-' +
        data.IMEI +
        '" title="Copiar tiempo de parada">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div ' +
        (hasPermission ? '' : 'style="display: none;"') +
        ' class="popup-footer">' +
        '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
        data.IMEI +
        '" id="custom-btn-1-' +
        data.IMEI +
        '" title="Ver historial del día">' +
        // '<i class="fas fa-history"></i>' +
        '<span>Recorrido hoy</span>' +
        '</button>' +
        '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
        data.IMEI +
        '" id="custom-btn-2-' +
        data.IMEI +
        '" title="Crear historial personalizado">' +
        // '<i class="fas fa-cog"></i>' +
        '<span>Elegir fecha</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<style>' +
        // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
        // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
        // '.leaflet-popup-close-button { display: none !important; }' +
        '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
        '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
        '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
        '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
        '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
        '.popup-body { padding: 8px 10px; background: white; }' +
        '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
        '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
        '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
        '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
        '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
        '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
        '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
        '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
        '.location-link:hover { text-decoration: underline; }' +
        '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
        '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
        '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
        '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
        '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
        '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
        '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
        '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
        '.btn-modern i { font-size: 10px; }' +
        '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
        '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
        '.copy-btn i { font-size: 10px; }' +
        '</style>';
    } else {
      popupText =
        '<div class="modern-popup-container">' +
        '<div class="popup-header">' +
        '<div class="vehicle-info">' +
        '<h6 class="vehicle-name" id="vehicle-name-' +
        data.IMEI +
        '" title="Copiar nombre del vehículo">' +
        data.name +
        '</h6>' +
        '<span class="speed-badge">' +
        data.speed +
        ' km/h</span>' +
        '</div>' +
        '</div>' +
        '<div class="popup-body">' +
        '<div class="info-grid">' +
        '<div class="info-item">' +
        '<i class="fas fa-user-circle"></i>' +
        '<span class="info-label">Conductor:</span>' +
        '<span class="info-value" id="driver-' +
        data.IMEI +
        '-content">' +
        data.namedriver +
        '</span>' +
        '<button class="copy-btn" id="driver-' +
        data.IMEI +
        '" title="Copiar conductor">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marker-alt"></i>' +
        '<span class="info-label">Ubicación:</span>' +
        '<a href="' +
        googleMapsLink +
        '" target="_blank" class="location-link" id="location-' +
        data.IMEI +
        '-content">' +
        data.latitud +
        ', ' +
        data.longitud +
        '</a>' +
        '<button class="copy-btn" id="location-' +
        data.IMEI +
        '" title="Copiar ubicación">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-map-marked-alt"></i>' +
        '<span class="info-label">Referencia:</span>' +
        '<span class="info-value" id="reference-' +
        data.IMEI +
        '-content">NN</span>' +
        '<button class="copy-btn" id="reference-' +
        data.IMEI +
        '" title="Copiar referencia">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-clock"></i>' +
        '<span class="info-label">Transmisión:</span>' +
        '<span class="info-value" id="transmission-' +
        data.IMEI +
        '-content">' +
        dt_tracker +
        '</span>' +
        '<button class="copy-btn" id="transmission-' +
        data.IMEI +
        '" title="Copiar transmisión">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '<div class="info-item">' +
        '<i class="fas fa-pause-circle"></i>' +
        '<span class="info-label">T. Detenido:</span>' +
        '<span class="info-value" id="stoptime-' +
        data.IMEI +
        '-content">' +
        this.time_stop +
        '</span>' +
        '<button class="copy-btn" id="stoptime-' +
        data.IMEI +
        '" title="Copiar tiempo de parada">' +
        '<i class="fas fa-copy"></i>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '<div ' +
        (hasPermission ? '' : 'style="display: none;"') +
        ' class="popup-footer">' +
        '<button class="btn-modern btn-primary custom-btn-1" data-imei="' +
        data.IMEI +
        '" id="custom-btn-1-' +
        data.IMEI +
        '" title="Ver historial del día">' +
        // '<i class="fas fa-history"></i>' +
        '<span>Recorrido hoy</span>' +
        '</button>' +
        '<button class="btn-modern btn-secondary custom-btn-2" data-imei="' +
        data.IMEI +
        '" id="custom-btn-2-' +
        data.IMEI +
        '" title="Crear historial personalizado">' +
        // '<i class="fas fa-cog"></i>' +
        '<span>Elegir fecha</span>' +
        '</button>' +
        '</div>' +
        '</div>' +
        '<style>' +
        // '.leaflet-popup-content-wrapper { padding: 0 !important; margin: 0 !important; }' +
        // '.leaflet-popup-content { margin: 0 !important; padding: 0 !important; }' +
        // '.leaflet-popup-close-button { display: none !important; }' +
        '.modern-popup-container { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; max-width: 280px; margin: 0; padding: 0; }' +
        '.popup-header { background: var(--gl-primary); color: white; padding: 8px 10px; border-radius: 4px 4px 0 0; }' +
        '.vehicle-info { display: flex; justify-content: space-between; align-items: center; }' +
        '.vehicle-name { margin: 0; font-size: 14px; font-weight: 600; }' +
        '.speed-badge { background: rgba(255,255,255,0.2); padding: 2px 8px; border-radius: 12px; font-size: 12px; font-weight: 500; }' +
        '.popup-body { padding: 8px 10px; background: white; }' +
        '.group-info { display: flex; align-items: center; gap: 6px; margin-bottom: 8px; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; }' +
        '.group-name { font-size: 11px; color: #6c757d; font-weight: 500; }' +
        '.info-grid { display: flex; flex-direction: column; gap: 6px; }' +
        '.info-item { display: flex; align-items: flex-start; gap: 6px; }' +
        '.info-item i { width: 14px; margin-top: 1px; font-size: 12px; }' +
        '.info-label { font-size: 11px; color: #6c757d; min-width: 70px; }' +
        '.info-value { font-size: 12px; color: #495057; flex: 1; }' +
        '.location-link { color: #007bff; text-decoration: none; font-size: 12px; flex: 1; }' +
        '.location-link:hover { text-decoration: underline; }' +
        '.popup-footer { padding: 6px 10px; background: #f8f9fa; border-radius: 0 0 4px 4px; display: flex; gap: 6px; }' +
        '.btn-modern { border: none; padding: 6px 12px; border-radius: 4px; font-size: 11px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: flex; align-items: center; gap: 4px; flex: 1; justify-content: center; }' +
        '.vehicle-name { cursor: pointer; transition: all 0.2s ease; }' +
        '.vehicle-name:hover { background: rgba(255,255,255,0.1); padding: 1px 4px; border-radius: 3px; }' +
        '.btn-modern.btn-primary { background: var(--gl-primary); color: white; }' +
        '.btn-modern.btn-primary:hover { background: #002244; transform: translateY(-1px); }' +
        '.btn-modern.btn-secondary { background: linear-gradient(135deg, #a8a8a8 0%, #8e8e8e 100%); color: white; }' +
        '.btn-modern.btn-secondary:hover { background: linear-gradient(135deg, #969696 0%, #7c7c7c 100%); transform: translateY(-1px); }' +
        '.btn-modern i { font-size: 10px; }' +
        '.copy-btn { background: none; border: none; color: #6c757d; cursor: pointer; padding: 1px 3px; margin-left: 6px; border-radius: 2px; transition: all 0.2s ease; }' +
        '.copy-btn:hover { background: #f8f9fa; color: #007bff; }' +
        '.copy-btn i { font-size: 10px; }' +
        '</style>';
    }

    const popupElement = document.getElementsByClassName('btn-history')[0];
    if (popupElement) {
      popupElement.addEventListener('click', () => {
        console.log(
          'Acción ejecutada Calculado en el botón del popup para el vehículo:',
          data.imei
        );
      });
    }

    const tempMarker = L.marker([data.latitud, data.longitud], {
      icon: iconMarker,
    })
      .setZIndexOffset(1)
      .bindPopup(popupText)
      .on('popupopen', () => {
        // Event listener al botón cuando se abre el popup
        document.getElementById('marker')?.addEventListener('click', () => {
          /* this.openHistorialDialog(data.imei); */
        });

        // Configurar listeners de copiado
        this.setCopyListener(`vehicle-name-${data.IMEI}`, data.name);
        this.setCopyListener(
          `driver-${data.IMEI}`,
          data.namedriver,
          `driver-${data.IMEI}-content`
        );
        this.setCopyListener(
          `location-${data.IMEI}`,
          `${data.latitud}, ${data.longitud}`,
          `location-${data.IMEI}-content`
        );
        this.setCopyListener(
          `reference-${data.IMEI}`,
          'NN',
          `reference-${data.IMEI}-content`
        );
        this.setCopyListener(
          `transmission-${data.IMEI}`,
          dt_tracker,
          `transmission-${data.IMEI}-content`
        );
        this.setCopyListener(
          `stoptime-${data.IMEI}`,
          this.time_stop,
          `stoptime-${data.IMEI}-content`
        );

        // Configurar listeners para los botones de acción
        document
          .getElementById(`custom-btn-1-${data.IMEI}`)
          ?.addEventListener('click', () => {
            this.onClickHistoryButton.emit({
              is_custom: false,
              imei: data.IMEI,
            });
          });

        document
          .getElementById(`custom-btn-2-${data.IMEI}`)
          ?.addEventListener('click', () => {
            this.onClickHistoryButton.emit({
              is_custom: true,
              imei: data.IMEI,
            });
          });
      });

    tempMarker.bindTooltip(` <span>${data.name}</span>`, {
      permanent: true,
      offset: [0, 12],
      className: 'vehicle-tooltip',
      direction: 'bottom',
    });

    let options = {
      imei: data.IMEI,
      name: data.name,
      nameconvoy: data.nameconvoy,
      namegrupo: data.namegrupo,
      nameoperation: data.nameoperation,
      namedriver: data.namedriver,
      longitud: data.longitud,
      latitud: data.latitud,
      speed: data.speed,
      dt_tracker: data.dt_tracker,
      paradaDesde: '',
      // vehicleService: this.vehicleService,
    };

    tempMarker.on('click', () => this.timeStop(options));

    this.marker[data.IMEI] = tempMarker;

    this.markerClusterGroup.addLayer(tempMarker);
    this.markerClusterGroup.addTo(this.map);
  }

  public changeClusteringVisibility(visibility: boolean) {
    this.clustering = visibility;
  }

  public get getClustering(): boolean {
    return this.clustering;
  }
  public timeChangeIconUrl(imei: string, tipo: string, key: any) {
    // this.timeWait = 15000; // 150 segundos en milisegundos

    if (this.timeNow[imei]) {
      clearTimeout(this.timeNow[imei]); // Limpia el temporizador existente si hay uno para este índice
      // console.log('SE LIMPIO EL TEMPORIZADOR del -->',imei);
    }
    const tiempoUltimaActualizacion = Date.now(); // Actualiza el tiempo de la última actualización para este índice
    // console.log('CREANDO TEMPORIZADOR NUEVO -->',imei);|
    this.timeNow[imei] = setTimeout(async () => {
      // Verifica si ha pasado el tiempo especificado desde la última actualización
      const tiempoActual = Date.now();
      const tiempoTranscurrido = tiempoActual - tiempoUltimaActualizacion;
      if (tiempoTranscurrido >= this.timeWait) {
        // Realiza la acción si ha pasado el tiempo especificado sin actualización
        console.log(
          '*************** PASO 2 Horas Cambiando color a default ---->',
          imei
        );

        // const iconUrl = custom_svg;
        const iconUrl = await this.userIconsService.getDirectionSvg(
          tipo,
          'default'
        );

        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'iconUrl'
        ] = iconUrl;
        if (this.userIconsService.changeItemIcon == ItemIcon.ONDAS) {
          this.markerClusterGroupOnda.getLayers()[key]['options']['icon'][
            'options'
          ]['iconUrl'] = './assets/images/objects/nuevo/gif/blanco.png';
        }
        this.markerClusterGroup.getLayers()[key]['options']['icon']['options'][
          'shadowUrl'
        ] = '';
      }
    }, this.timeWait);
  }

  private async hasParamIgnition(vehicle: UserTracker): Promise<boolean> {
    return (
      vehicle.parametros!.includes('di4=') ||
      vehicle.parametros!.includes('Custom_ign=')
    );
  }
  private async checkParamIgnition(vehicle: UserTracker): Promise<boolean> {
    return (
      vehicle.parametros!.includes('di4=1') ||
      vehicle.parametros!.includes('Custom_ign=1') ||
      vehicle.v_on == 1
    );
    // return (vehicle.v_on == 1);
  }
  private async setIconUrlByState(vehicle: UserTracker) {
    let state: string = 'default';
    let iconUrl: any;
    if (
      this.userIconsService.changeItemIcon == ItemIcon.VEHICLES &&
      this.userIconsService.stateVehiclesDirectionSvg == true
    ) {
      state = this.getStateVehicle(vehicle);
      iconUrl = await this.userIconsService.getDirectionSvg(
        vehicle.tipo!,
        state
      );
    } else {
      iconUrl = await this.userIconsService.getDirectionSvg(
        vehicle.tipo!,
        state
      );
    }
    // console.log(vehicle.IMEI,vehicle.tipo,state);
    return iconUrl;
  }
  private async setIconUrlOndaByState(vehicle: UserTracker) {
    const iconOndaUrl = await this.getUrlByStateOndas(vehicle);
    return iconOndaUrl;
  }

  private getIconUrlTransmission(vehicle: UserTracker): string {
    let iconUrl = '';
    if (vehicle.IMEI) {
      const imei = vehicle.IMEI;

      if (imei) {
        let unit = this.getUnitTransmissionByIMEI(imei);
        if (unit) {
          (iconUrl = this.userIconsService.getTransmissionIconUnsafe(
            unit.unitTypeId,
            unit.transmissionStatusId.toString()
          )),
            (vehicle.unitTransmission = unit.transmissionStatusId.toString());
        }
      }
    }
    if (!iconUrl) {
      iconUrl = this.userIconsService.getDirectionSvg(vehicle.tipo!, 'default');
    }

    return iconUrl;
  }
  private getIconUrlTransmissionDirection(
    vehicle: UserTracker,
    direction: string
  ): string {
    let iconUrl = '';
    if (vehicle.IMEI) {
      const imei = vehicle.IMEI;

      if (imei) {
        let unit = this.getUnitTransmissionByIMEI(imei);
        if (unit) {
          iconUrl = this.userIconsService.getTransmissionIconDirectionUnsafe(
            unit.unitTypeId,
            unit.transmissionStatusId.toString(),
            direction
          );
          vehicle.unitTransmission = unit.transmissionStatusId.toString();
        }
      }
    }
    if (!iconUrl) {
      iconUrl = this.userIconsService.getDirectionSvg(
        vehicle.tipo!,
        'default',
        direction
      );
      vehicle.direction = direction;
    }

    return iconUrl;
  }

  private setCopyListener(id: string, value: string, contentId?: string) {
    const elButton = document.getElementById(id);
    const elContent = contentId
      ? document.getElementById(contentId)
      : document.getElementById(id);
    if (elButton) {
      elButton.onclick = () => {
        navigator.clipboard.writeText(value);
        if (elContent) {
          const original = elContent.innerHTML;
          if (original === '¡Copiado!') return;
          elContent.innerHTML = '¡Copiado!';
          setTimeout(() => {
            elContent.innerHTML = original;
          }, 1500);
        }
      };
    }
  }
}
